import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { login } from "../../context/AuthContext";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const links = [
  { label: "Training", href: "#courses" },
  { label: "Doctrine", href: "#manifesto" },
  { label: "Instructor", href: "#instructor" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-brand-bg/80 backdrop-blur-2xl border-b border-white/5" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/logo-mark.png" alt="Midwest Made" className="h-9 w-9 group-hover:scale-110 transition-transform duration-500" />
          <span className="font-heading font-black text-lg tracking-tight uppercase text-brand-ink leading-none">
            Midwest<span className="text-brand-orange">Made</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-brand-muted hover:text-brand-ink transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {user ? (
          <button
            onClick={() => navigate("/dashboard")}
            data-testid="nav-dashboard-btn"
            className="font-mono text-xs uppercase tracking-[0.2em] bg-brand-orange text-brand-bg px-5 py-3 hover:bg-brand-ink transition-colors"
          >
            My Portal
          </button>
        ) : (
          <button
            onClick={login}
            data-testid="nav-login-btn"
            className="font-mono text-xs uppercase tracking-[0.2em] border border-white/20 text-brand-ink px-5 py-3 hover:bg-brand-orange hover:border-brand-orange hover:text-brand-bg transition-colors"
          >
            Member Login
          </button>
        )}
      </div>
    </motion.header>
  );
}
